// import "./app.css";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import {
  goTo,
  getRecommendedRoute,
  getRouteObsrv,
  navigateFromDeniedPath,
  isRouteAllowed,
} from "./services/flow.service";
import Storage from "./services/storage.service";

const history = createBrowserHistory({
  basename: "", 
  hashType: "hash",
});

export default class Redirecter extends Component {
  old_route = null;

  state = {
    routeTo: null,
  };

  componentDidMount() {
    let route = getRecommendedRoute("HomeRouter");
    goTo(route);
    Storage.setShared("loading_text", "");

    history.listen(({ action, location }) => {
      let location_from_url = location.hash.substring(1, location.hash.length);
      if (location_from_url !== this.old_route) {
        if (isRouteAllowed(location_from_url)) {
          goTo(location_from_url);
        } else {
          navigateFromDeniedPath(location_from_url);
        }
      }
    });

    getRouteObsrv().subscribe((data) => {
      let hash = history.location.hash;
      if (data && (hash !== "#" + data || data !== this.old_route)) {
        this.setState({ routeTo: data });
        Storage.set('currentRoute',  data, true)
        this.old_route = data;
        history.push("#" + data);
      }
    });
  }

  render() {
    let goto = "";
    if (this.state.routeTo) {
      goto = <Redirect to={this.state.routeTo} key={Date.now()} />;
    }
    return goto;
  }
}
